'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'chevrons-up';
var width = 448;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M241.5 39c-9.4-9.4-24.6-9.4-33.9 0L7.5 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183 183 183c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241.5 39zm200 392l-200-200c-9.4-9.4-24.6-9.4-33.9 0L7.5 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183 183 183c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;